import {Injectable} from '@angular/core';
import {FieldUiDataObj} from '../../../../../../generated/generated-core.model';
import {AbstractControl, FormGroup} from '@angular/forms';
import {MxAssignmentGridDialogConfig} from '../../../../mx-assignment-grid/services/mx-assignment-grid-dialog-config';
import {MxComboBoxConfig} from '../components/mx-combo-box-field/mx-combo-box-field.component';
import {BoDatePickerConfig} from '../components/mx-date-picker/mx-date-picker.component';
import {ContainerCustomizer} from './mx-container-customizer';


export class FieldCtx {
    name: string;
    field: FieldUiDataObj;
    form: FormGroup;
    control: AbstractControl;
}

export type PrimitiveInputValue = number | string | boolean;

export class MxFieldConfig {
    assignmentConfig?: MxAssignmentGridDialogConfig;
    comboBoxConfig?: MxComboBoxConfig;
    datePickerConfig?: BoDatePickerConfig;
    displayFormat?: (value: PrimitiveInputValue) => PrimitiveInputValue;
    clickHandler?: (callbackFn: (newValue: any) => void, initValue?: PrimitiveInputValue) => any;
    viewUrlFn?: () => string;
    icon?: string;
    style?: string;
    showClearButton?: boolean;
}


@Injectable()
export class MxFieldCustomizerService extends ContainerCustomizer<FieldCtx> {

    constructor() {
        super();
    }

}
